import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from '@app/core/services/config.service';
import { GlobalConstants } from '@app/portal/global-constants';
import { firstValueFrom } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-footer-application',
  templateUrl: './footer-application.component.html'
})
export class FooterApplicationComponent implements OnInit {
  appTitle = GlobalConstants.appInfo.appTitle;
  appYear: number = new Date().getFullYear();
  appVersion?: string;

  constructor(private readonly configService: ConfigService, private readonly httpClient: HttpClient) { }

  ngOnInit(): void {
    let publicPath = this.configService.appConfig.api.publicPath;

    firstValueFrom(this.httpClient.get(`${publicPath}/uo/version`, { responseType: 'text' }))
      .then(response =>
        this.appVersion = response);
  }
}